const siteConfig = {
  brandName: "junnchard",
  shortName: "J",
  logo: "/brand-mark.svg",
  tagline: "Practical comfort for everyday journeys outdoors.",
  description:
    "Technical outdoor clothing, footwear and equipment made for changing weather, long trails and everyday adventure.",
  currency: "USD",
  locale: "en-SG",
  countryCode: "SG",
  countryName: "Singapore",
  freeShippingThreshold: Number.POSITIVE_INFINITY,
  shippingCost: 9.99,
  expressShippingCost: 9.99,
  returnsWindow: 30,
  contact: {
    email: "mall@junnchard.life",
    hours: "Monday to Friday, 09:00–17:00",
    address: "19 Lynwood Grove, Singapore 358663",
  },
  social: {},
  services: [
    {
      title: "Free returns within 30 days",
      text: "Simple prepaid returns on unworn items.",
    },
    {
      title: "Tracked delivery for $9.99",
      text: "Clear, reliable delivery updates for every order.",
    },
    {
      title: "Secure checkout",
      text: "Payment is completed through our protected payment partner.",
    },
  ],
};

export default siteConfig;
